//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import layer from '@/components/layer/layer.vue'

export default {
  data() {
    return {
    }
  },
  components: {
    layer,
  },
  props: {
    classify: {
      type: Boolean,
      default:false
    }
  },
  created () {
  },
  watch: {

  },
  methods: {
    close(){
      this.$emit("close")
      
    }
  },
  
}
